import z from "zod";
import { createServerFn } from "@tanstack/react-start";
import { and, eq, lt, or, sql } from "drizzle-orm";
import { poll, user } from "@/db/schema";
import { fetchPolls } from "@/lib/server-functions/helper-functions/fetch-polls";
import { getRequest } from "@tanstack/react-start/server";
import { auth } from "@/lib/better-auth/auth";

const getPollsSchema = z.object({
  pageParam: z.string().optional(),
  authorUsername: z.string().optional(),
  sort: z.enum(["best", "new"]).optional(),
  onlyFollowing: z.boolean().optional(),
  nsfw: z.boolean().optional(),
});

export const getPolls = createServerFn({ method: "GET" })
  .inputValidator(getPollsSchema)
  .handler(async (ctx) => {
    const {
      pageParam,
      authorUsername,
      sort = "best",
      onlyFollowing,
      nsfw = false,
    } = ctx.data;
    const request = getRequest();
    const userSession = await auth.api.getSession({ headers: request.headers });
    const currentUserId = userSession?.user?.id ?? null;

    const where: any[] = [];
    if (authorUsername) where.push(eq(user.username, authorUsername));
    if (onlyFollowing && currentUserId) {
      where.push(
        or(
          sql`${user.id} IN (SELECT following_id FROM user_follow WHERE follower_id = ${currentUserId})`
        )
      );
    }

    where.push(eq(poll.isNsfw, !!nsfw));

    if (pageParam) {
      const { lastScore, lastId } = JSON.parse(pageParam);

      if (sort === "best") {
        where.push(
          or(
            lt(poll.reactionScore, lastScore),
            and(eq(poll.reactionScore, lastScore), lt(poll.id, lastId))
          )
        );
      } else {
        where.push(lt(poll.id, lastId));
      }
    }

    return fetchPolls({
      where,
      currentUserId,
      sort,
    });
  });
